export default "__VITE_ASSET__71d7c590__"